<app-company-select
  [onlyActive]="false"
  (select)="onSelect($event)"
  [hideLabel]="true"
  [parentFormGroup]="form"
  class="kendo-select-filter"
  [isModal]="false"
>
</app-company-select>
